/**
 * Rezeptgruppen actions.
 * @module actions/Produkt
 */

import {
  GET_REZEPTGRUPPEN,
  GET_REZEPTGRUPPEBYID,
  CREATE_REZEPTGRUPPE,
  UPDATE_REZEPTGRUPPE,
  DELETE_REZEPTGRUPPE,
} from '../../constants/ActionTypes';

/**
 * Get Produkt items.
 * @function getProduct
 * @param {string} id Produkt id
 * @returns {Object} Produkt action.
 */
export function getRezeptgruppen({
  showDeleted = false,
  getAll = false,
  batchingParameters = {},
}) {
  const {
    limit = 10,
    skip = 0,
    sort_by = '',
    asc = false,
    searchTerms = '',
  } = batchingParameters;
  // Initialize an empty array to store query parameters
  const queryParams = [];
  if (sort_by) {
    queryParams.push(`sort_by=${sort_by}`);
  }
  if (searchTerms) {
    queryParams.push(`search=${encodeURIComponent(searchTerms)}`);
  }
  // Construct the pathSuffix by joining query parameters with '&'
  let pathSuffix = `?limit=${limit}&skip=${skip}&asc=${asc}`;
  if (queryParams.length > 0) {
    pathSuffix += `&${queryParams.join('&')}`;
  }
  if (showDeleted) {
    return {
      type: GET_REZEPTGRUPPEN,
      request: {
        op: 'get',
        path: `/@rezeptgruppen/deleted${pathSuffix}`,
      },
    };
  } else if (getAll) {
    return {
      type: GET_REZEPTGRUPPEN,
      request: {
        op: 'get',
        path: `/@rezeptgruppen/all`,
      },
    };
  }

  return {
    type: GET_REZEPTGRUPPEN,
    request: {
      op: 'get',
      path: `/@rezeptgruppen${pathSuffix}`,
    },
  };
}

/**
 * Get Benutzer item.
 * @function getBenutzerByID
 * @param {string} id Benutzer id
 * @returns {Object} Benutzer action.
 */
export function getRezeptgruppeByID(id) {
  return {
    type: GET_REZEPTGRUPPEBYID,
    request: {
      op: 'get',
      path: `/@rezeptgruppen/${id}`,
    },
  };
}

/**
 * Create a new Rezeptgruppe.
 * @function createRezeptgruppe
 * @param {Object} formData The data of the new Rezeptgruppe
 * @returns {Object} Rezeptgruppe action.
 */
export function createRezeptgruppe(formData) {
  return {
    type: CREATE_REZEPTGRUPPE,
    request: {
      op: 'post',
      path: '/@rezeptgruppen',
      data: formData,
    },
  };
}

/**
 * Update a new Rezeptgruppe.
 * @function createRezeptgruppe
 * @param {Object} formData The data of the new Rezeptgruppe
 * @returns {Object} Rezeptgruppe action.
 */
export function updateRezeptgruppe(id, formData) {
  return {
    type: UPDATE_REZEPTGRUPPE,
    request: {
      op: 'patch',
      path: `/@rezeptgruppen/${id}`,
      data: formData,
    },
  };
}

/**
 * Delete a Rezeptgruppe.
 * @function createRezeptgruppe
 * @returns {Object} Success Message;
 */
export function deleteRezeptgruppe(id) {
  return {
    type: DELETE_REZEPTGRUPPE,
    request: {
      op: 'del',
      path: `/@rezeptgruppen/${id}`,
    },
  };
}
